import { render, staticRenderFns } from "./PalattePicker.vue?vue&type=template&id=bb5132f4&scoped=true&"
import script from "./PalattePicker.vue?vue&type=script&lang=js&"
export * from "./PalattePicker.vue?vue&type=script&lang=js&"
import style0 from "./PalattePicker.vue?vue&type=style&index=0&id=bb5132f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5132f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VRow})
